import { CoherencePanel } from '@coherence-design-system/controls';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';
import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { DefaultButton } from '@micro-frontend-react/employee-experience/lib/Buttons/DefaultButton';
import * as React from 'react';
import { PageContainer } from '../../Home.styled';
import { ILetterTemplate } from '../../../models/ILetterTemplate';
import * as styled from './SuccessfulGenerationPanel.styled';
import { MetadataContext } from '../../../shared/MetadataContext';

export interface ISuccessfulGenerationPanelProps {
  selectedLetter: ILetterTemplate;
}

export function SuccessfulGenerationPanel(
  props: ISuccessfulGenerationPanelProps
): React.ReactElement {
  const { selectedLetter } = props;
  const { telemetryClient } = React.useContext(
    Context as React.Context<IEmployeeExperienceContext>
  );

  return (
    <>
      <MetadataContext.Consumer>
        {(context) => (
          <CoherencePanel
            isOpen={context.showSuccessGenerationPanel}
            onDismiss={() => {
              context.toggleSuccessGenerationPanel(false);
            }}
            customWidth={`900px`}
            isLightDismiss={true}
            titleText={`${selectedLetter?.name}`}
            closeButtonAriaLabel="Close panel"
            hasCloseButton={true}
            overlayProps={{
              isDarkThemed: true,
            }}
            telemetryHook={telemetryClient}
          >
            <PageContainer data-testid="successful-generation-panel">
              <styled.SuccessGenerationContainer>
                <styled.SuccessImage
                  src={`./assets/successLetterGeneration.png`}
                  role="presentation"
                />
                <styled.BreakFlexDiv />
                <styled.SuccessMessage>
                  Your letter has been generated and downloaded to your device.
                </styled.SuccessMessage>
                <styled.BreakFlexDiv />
                <DefaultButton
                  text="Start a new one"
                  title="Start a new one"
                  usageEvent={{
                    feature: 'EVL',
                    subFeature: 'SuccessfulGenerationPanel.StartNewButton',
                  }}
                  style={{ marginTop: 20 }}
                  onClick={() => {
                    context.clearSelectedLetter();
                    context.toggleSuccessGenerationPanel(false);
                  }}
                />
              </styled.SuccessGenerationContainer>
            </PageContainer>
          </CoherencePanel>
        )}
      </MetadataContext.Consumer>
    </>
  );
}
